type Props = {
  image?: string
  fallbackImage: string
}

export const useImageHandler = ({ image, fallbackImage }: Props) => {
  const isFallbackImage = ref(false)

  const imageSrc = computed(() => {
    if (isFallbackImage.value || !image) return fallbackImage

    return image
  })

  const setImageError = () => {
    isFallbackImage.value = true
  }

  return {
    imageSrc,
    setImageError,
  }
}
